import React from 'react'

const ModeSelect = props => {
    const { active, steps, selectStep, mode } = props;

    return (mode === null) ? (<div id="mode-select">
        <div className="row">
            <h3>Select an Event Type</h3>
        </div>
        <div className="btn-group btn-group-lg">
            <button
                type="button"
                className={'btn btn-' + ((mode == 'encoder') ? 'primary active' : 'default')}
                onClick={props.selectMode.bind(null, 'encoder', false)}>
                Live Event
            </button>
            <button
                type="button"
                className={'btn btn-' + ((mode == 'media') ? 'primary active' : 'default')}
                onClick={props.selectMode.bind(null, 'media', false)}>
                Event from Media
            </button>
        </div>
        <div className="row">
            <p><strong>Live</strong> mode will allow you select an Encoder to assign for an Event that will occur in the future whereas a <strong>Media</strong> based Event is generally selected when you intend to upload existing Video Media you wish to Publish to the web.</p>
        </div>
    </div>) : null;
}

export default ModeSelect
